import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
import { SensorResourceFieldsFragmentDoc } from './Sensors.generated'
const defaultOptions = {}
export type IMutableLocationBaseFields_Area_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Building_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Gate_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Integration_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_InteriorDoor_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_InteriorPath_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Level_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Location_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_LogisticsObject_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Material_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_OffloadingEquipment_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_ProjectLocation_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Route_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Sensor_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Staging_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_VerticalObject_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFields_Zone_Fragment = {
  color: string
  iconName: string
  code?: string | null
  stxResourceId?: string | null
  permittedCompanies?: Array<any | null> | null
  isBookable: boolean
  maxOverlappingDeliveries?: number | null
  maxBookingDuration?: number | null
  assignedSitemaps?: Array<string | null> | null
  assignedGlobes?: Array<string | null> | null
  operatingIntervals?: Array<{
    startDate: any
    endDate: any
    isDaily?: boolean | null
    dayOfWeek?: number | null
  } | null> | null
  parent?: { parentId?: any | null } | null
}

export type IMutableLocationBaseFieldsFragment =
  | IMutableLocationBaseFields_Area_Fragment
  | IMutableLocationBaseFields_Building_Fragment
  | IMutableLocationBaseFields_Gate_Fragment
  | IMutableLocationBaseFields_Integration_Fragment
  | IMutableLocationBaseFields_InteriorDoor_Fragment
  | IMutableLocationBaseFields_InteriorPath_Fragment
  | IMutableLocationBaseFields_Level_Fragment
  | IMutableLocationBaseFields_Location_Fragment
  | IMutableLocationBaseFields_LogisticsObject_Fragment
  | IMutableLocationBaseFields_Material_Fragment
  | IMutableLocationBaseFields_OffloadingEquipment_Fragment
  | IMutableLocationBaseFields_ProjectLocation_Fragment
  | IMutableLocationBaseFields_Route_Fragment
  | IMutableLocationBaseFields_Sensor_Fragment
  | IMutableLocationBaseFields_Staging_Fragment
  | IMutableLocationBaseFields_VerticalObject_Fragment
  | IMutableLocationBaseFields_Zone_Fragment

export type IWorkflowLocationRestrictionFieldsFragment = {
  id?: any | null
  projectId: any
  restrictionType: Types.RestrictionType
  workflowIds?: Array<any | null> | null
  values?: Array<string | null> | null
  locationId: any
}

export type ILocationsByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type ILocationsByProjectIdQuery = {
  locations?: {
    data: Array<
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          levelsOrder?: Array<string | null> | null
          groundLevel?: string | null
          isGroundIndexZero?: boolean | null
          skipLevelIndexTemplate?: string | null
          levelBaseName?: string | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          metadata?: Array<{
            key?: string | null
            value?: string | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isNameImplicit?: boolean | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isNameImplicit?: boolean | null
          levelsOrder?: Array<string | null> | null
          groundLevel?: string | null
          isGroundIndexZero?: boolean | null
          skipLevelIndexTemplate?: string | null
          levelBaseName?: string | null
          accessibleLevels?: Array<any | null> | null
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          isLinked: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          levelsClosures?: Array<{
            levels?: Array<any | null> | null
            interval?: { startDate: any; endDate: any } | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          rollups?: any | null
          isBookable: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          showInMap: boolean
          accessibleLevels?: Array<any | null> | null
          rollups?: any | null
          isBookable: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          linkedSensor?: {
            id?: any | null
            name: string
            infuseId?: string | null
            data?: any | null
          } | null
          effectivePosition?: {
            source: Types.PositionSource
            latitude?: number | null
            longitude?: number | null
            lastUpdatedAt?: any | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isLinked: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          infuseId?: string | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
          linkedEquipment?: {
            id?: any | null
            name: string
            data?: any | null
            color: string
            iconName: string
          } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          accessibleLevels?: Array<any | null> | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          levelsClosures?: Array<{
            levels?: Array<any | null> | null
            interval?: { startDate: any; endDate: any } | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
    >
  } | null
}

export type IValidateLocationRestrictionsForTimePeriodsQueryVariables =
  Types.Exact<{
    timePeriods: Array<Types.IDateIntervalInput> | Types.IDateIntervalInput
    workflowId: Types.Scalars['ObjectId']['input']
    locationIds:
      | Array<Types.Scalars['ObjectId']['input']>
      | Types.Scalars['ObjectId']['input']
    permitId?: Types.InputMaybe<Types.Scalars['ObjectId']['input']>
  }>

export type IValidateLocationRestrictionsForTimePeriodsQuery = {
  validateLocationRestrictionsForTimePeriods?: Array<{
    isValid?: boolean | null
    timePeriod?: { startDate: any; endDate: any } | null
    locationResults?: Array<{
      locationId: any
      isOverlappingAllowed: boolean
      violatedRestrictions: Array<string | null>
      conflictingPermits?: Array<{
        id?: any | null
        code?: string | null
        startDate: any
        endDate: any
      } | null> | null
    } | null> | null
  } | null> | null
}

export type ISaveEquipmentsMutationVariables = Types.Exact<{
  equipments:
    | Array<Types.InputMaybe<Types.IOffloadingEquipmentInput>>
    | Types.InputMaybe<Types.IOffloadingEquipmentInput>
}>

export type ISaveEquipmentsMutation = {
  saveManyOffloadingEquipments?: Array<{ id?: any | null } | null> | null
}

export type IUpdateLocationsPermittedCompaniesMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  permittedCompanies:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
}>

export type IUpdateLocationsPermittedCompaniesMutation = {
  updateLocationsPermittedCompanies?: Array<any> | null
}

export type IUpdateLocationsIsBookableMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  isBookable: Types.Scalars['Boolean']['input']
}>

export type IUpdateLocationsIsBookableMutation = {
  updateLocationsIsBookable?: Array<any> | null
}

export type IUpdateLocationsShowInMapMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  showInMap: Types.Scalars['Boolean']['input']
}>

export type IUpdateLocationsShowInMapMutation = {
  updateLocationsShowInMap?: Array<any> | null
}

export type IUpdateLocationsOperatingIntervalsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  operatingIntervals:
    | Array<Types.InputMaybe<Types.IDateIntervalInput>>
    | Types.InputMaybe<Types.IDateIntervalInput>
}>

export type IUpdateLocationsOperatingIntervalsMutation = {
  updateLocationsOperatingIntervals?: Array<any> | null
}

export type ISaveIntegrationsMutationVariables = Types.Exact<{
  integrations:
    | Array<Types.InputMaybe<Types.IIntegrationInput>>
    | Types.InputMaybe<Types.IIntegrationInput>
}>

export type ISaveIntegrationsMutation = {
  saveManyIntegrations?: Array<{ id?: any | null } | null> | null
}

export type IDeleteLocationsMutationVariables = Types.Exact<{
  ids:
    | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
    | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IDeleteLocationsMutation = {
  softDeleteManyLocations?: boolean | null
}

export type ISaveManyWorkflowLocationRestrictionsMutationVariables =
  Types.Exact<{
    workflowLocationRestrictions:
      | Array<Types.InputMaybe<Types.IWorkflowLocationRestrictionInput>>
      | Types.InputMaybe<Types.IWorkflowLocationRestrictionInput>
  }>

export type ISaveManyWorkflowLocationRestrictionsMutation = {
  saveManyWorkflowLocationRestrictions?: Array<{
    id?: any | null
  } | null> | null
}

export type IDeleteManyWorkflowLocationRestrictionsMutationVariables =
  Types.Exact<{
    ids:
      | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
      | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
  }>

export type IDeleteManyWorkflowLocationRestrictionsMutation = {
  deleteManyWorkflowLocationRestrictions?: boolean | null
}

export type IResourceControlCascadeFieldsFragment = {
  affectedPermitTypeCount: number
  totalRemovals: number
  failedLocationIds?: Array<any> | null
  affectedPermitTypes?: Array<{
    permitTypeId: any
    permitTypeName?: string | null
    permitTypeType?: string | null
    removals?: Array<{
      surface: Types.CascadeSurface
      resourceId?: string | null
      fieldId?: any | null
      entryOrRuleDeleted: boolean
    }> | null
  }> | null
}

export type IDisableLocationsAndClearControlsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
}>

export type IDisableLocationsAndClearControlsMutation = {
  disableLocationsAndClearControls?: {
    affectedPermitTypeCount: number
    totalRemovals: number
    failedLocationIds?: Array<any> | null
    affectedPermitTypes?: Array<{
      permitTypeId: any
      permitTypeName?: string | null
      permitTypeType?: string | null
      removals?: Array<{
        surface: Types.CascadeSurface
        resourceId?: string | null
        fieldId?: any | null
        entryOrRuleDeleted: boolean
      }> | null
    }> | null
  } | null
}

export type IUpdateResourceControlsMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  permittedCompanies?: Types.InputMaybe<
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  >
  operatingIntervals?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.IDateIntervalInput>>
    | Types.InputMaybe<Types.IDateIntervalInput>
  >
  isBookable?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
  workflowRestrictions?: Types.InputMaybe<
    | Array<Types.IUpdateResourceControlsRestrictionInput>
    | Types.IUpdateResourceControlsRestrictionInput
  >
  closures?: Types.InputMaybe<
    | Array<Types.ILocationClosureIntervalInput>
    | Types.ILocationClosureIntervalInput
  >
}>

export type IUpdateResourceControlsMutation = {
  updateResourceControls?: {
    affectedPermitTypeCount: number
    totalRemovals: number
    failedLocationIds?: Array<any> | null
    affectedPermitTypes?: Array<{
      permitTypeId: any
      permitTypeName?: string | null
      permitTypeType?: string | null
      removals?: Array<{
        surface: Types.CascadeSurface
        resourceId?: string | null
        fieldId?: any | null
        entryOrRuleDeleted: boolean
      }> | null
    }> | null
  } | null
}

export type IPreviewResourceControlCascadeQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  locationIds:
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  proposedIsBookable?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type IPreviewResourceControlCascadeQuery = {
  previewResourceControlCascade?: {
    affectedPermitTypeCount: number
    totalRemovals: number
    failedLocationIds?: Array<any> | null
    affectedPermitTypes?: Array<{
      permitTypeId: any
      permitTypeName?: string | null
      permitTypeType?: string | null
      removals?: Array<{
        surface: Types.CascadeSurface
        resourceId?: string | null
        fieldId?: any | null
        entryOrRuleDeleted: boolean
      }> | null
    }> | null
  } | null
}

export type IListenToWorkflowLocationRestrictionSubscriptionVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
  }>

export type IListenToWorkflowLocationRestrictionSubscription = {
  workflowLocationRestriction?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      restrictionType: Types.RestrictionType
      workflowIds?: Array<any | null> | null
      values?: Array<string | null> | null
      locationId: any
    } | null
  } | null
}

export type IListenLocationsByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenLocationsByProjectIdSubscription = {
  location?: {
    id?: any | null
    item?:
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          levelsOrder?: Array<string | null> | null
          groundLevel?: string | null
          isGroundIndexZero?: boolean | null
          skipLevelIndexTemplate?: string | null
          levelBaseName?: string | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          metadata?: Array<{
            key?: string | null
            value?: string | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isNameImplicit?: boolean | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isNameImplicit?: boolean | null
          levelsOrder?: Array<string | null> | null
          groundLevel?: string | null
          isGroundIndexZero?: boolean | null
          skipLevelIndexTemplate?: string | null
          levelBaseName?: string | null
          accessibleLevels?: Array<any | null> | null
          maxHeight?: number | null
          maxWidth?: number | null
          maxWeight?: number | null
          isLinked: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          levelsClosures?: Array<{
            levels?: Array<any | null> | null
            interval?: { startDate: any; endDate: any } | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          rollups?: any | null
          isBookable: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          showInMap: boolean
          accessibleLevels?: Array<any | null> | null
          rollups?: any | null
          isBookable: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          linkedSensor?: {
            id?: any | null
            name: string
            infuseId?: string | null
            data?: any | null
          } | null
          effectivePosition?: {
            source: Types.PositionSource
            latitude?: number | null
            longitude?: number | null
            lastUpdatedAt?: any | null
          } | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          isLinked: boolean
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          infuseId?: string | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
          linkedEquipment?: {
            id?: any | null
            name: string
            data?: any | null
            color: string
            iconName: string
          } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          accessibleLevels?: Array<any | null> | null
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          levelsClosures?: Array<{
            levels?: Array<any | null> | null
            interval?: { startDate: any; endDate: any } | null
          } | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          projectId: any
          type?: Types.LocationType | null
          name: string
          color: string
          iconName: string
          permittedCompanies?: Array<any | null> | null
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          code?: string | null
          stxResourceId?: string | null
          templateId?: string | null
          data?: any | null
          isBookable: boolean
          showInMap: boolean
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          isDeleted: boolean
          createdAt?: any | null
          updatedAt?: any | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          workflowRestrictions?: {
            maxBookingDurations?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
            maxOverlappingBookings?: Array<{
              id?: any | null
              projectId: any
              restrictionType: Types.RestrictionType
              workflowIds?: Array<any | null> | null
              values?: Array<string | null> | null
              locationId: any
            } | null> | null
          } | null
          parent?: { parentId?: any | null } | null
        }
      | null
  } | null
}

export const MutableLocationBaseFieldsFragmentDoc = gql`
  fragment MutableLocationBaseFields on LocationBase {
    color
    iconName
    code
    stxResourceId
    operatingIntervals {
      startDate
      endDate
      isDaily
      dayOfWeek
    }
    permittedCompanies
    isBookable
    maxOverlappingDeliveries
    maxBookingDuration
    assignedSitemaps
    assignedGlobes
    parent {
      parentId
    }
  }
`
export const WorkflowLocationRestrictionFieldsFragmentDoc = gql`
  fragment WorkflowLocationRestrictionFields on WorkflowLocationRestriction {
    id
    projectId
    restrictionType
    workflowIds
    values
    locationId
  }
`
export const ResourceControlCascadeFieldsFragmentDoc = gql`
  fragment ResourceControlCascadeFields on ResourceControlCascadeResult {
    affectedPermitTypeCount
    totalRemovals
    failedLocationIds
    affectedPermitTypes {
      permitTypeId
      permitTypeName
      permitTypeType
      removals {
        surface
        resourceId
        fieldId
        entryOrRuleDeleted
      }
    }
  }
`
export const LocationsByProjectIdDocument = gql`
  query LocationsByProjectId($projectId: ObjectId!) {
    locations(
      projectId: $projectId
      offset: 0
      limit: 10000000
      sort: { by: "id", order: ASCENDING }
    ) {
      data {
        id
        projectId
        type
        name
        operatingIntervals {
          startDate
          endDate
          isDaily
          dayOfWeek
        }
        color
        iconName
        permittedCompanies
        maxOverlappingDeliveries
        maxBookingDuration
        workflowRestrictions {
          maxBookingDurations {
            ...WorkflowLocationRestrictionFields
          }
          maxOverlappingBookings {
            ...WorkflowLocationRestrictionFields
          }
        }
        code
        stxResourceId
        templateId
        data
        isBookable
        showInMap
        assignedSitemaps
        assignedGlobes
        isDeleted
        parent {
          parentId
        }
        ... on Integration {
          metadata {
            key
            value
          }
        }
        ... on Location {
          isNameImplicit
          levelsOrder
          groundLevel
          isGroundIndexZero
          skipLevelIndexTemplate
          levelBaseName
          accessibleLevels
          levelsClosures {
            levels
            interval {
              startDate
              endDate
            }
          }
          maxHeight
          maxWidth
          maxWeight
          isLinked
        }
        ... on Level {
          isNameImplicit
        }
        ... on Building {
          levelsOrder
          groundLevel
          isGroundIndexZero
          skipLevelIndexTemplate
          levelBaseName
        }
        ... on VerticalObject {
          accessibleLevels
          levelsClosures {
            levels
            interval {
              startDate
              endDate
            }
          }
        }
        ... on OffloadingEquipment {
          templateId
          data
          showInMap
          accessibleLevels
          rollups
          isBookable
          linkedSensor {
            id
            name
            infuseId
            data
          }
          effectivePosition {
            source
            latitude
            longitude
            lastUpdatedAt
          }
        }
        ... on Sensor {
          ...SensorResourceFields
        }
        ... on Material {
          templateId
          data
          rollups
          isBookable
        }
        ... on InteriorDoor {
          maxHeight
          maxWidth
          maxWeight
        }
        ... on InteriorPath {
          maxHeight
          maxWidth
          maxWeight
        }
        ... on ProjectLocation {
          isLinked
        }
        createdAt
        updatedAt
      }
    }
  }
  ${WorkflowLocationRestrictionFieldsFragmentDoc}
  ${SensorResourceFieldsFragmentDoc}
`

/**
 * __useLocationsByProjectIdQuery__
 *
 * To run a query within a React component, call `useLocationsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLocationsByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ILocationsByProjectIdQuery,
    ILocationsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ILocationsByProjectIdQuery,
    ILocationsByProjectIdQueryVariables
  >(LocationsByProjectIdDocument, options)
}
export function useLocationsByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ILocationsByProjectIdQuery,
    ILocationsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ILocationsByProjectIdQuery,
    ILocationsByProjectIdQueryVariables
  >(LocationsByProjectIdDocument, options)
}
export type LocationsByProjectIdQueryHookResult = ReturnType<
  typeof useLocationsByProjectIdQuery
>
export type LocationsByProjectIdLazyQueryHookResult = ReturnType<
  typeof useLocationsByProjectIdLazyQuery
>
export type LocationsByProjectIdQueryResult = Apollo.QueryResult<
  ILocationsByProjectIdQuery,
  ILocationsByProjectIdQueryVariables
>
export const ValidateLocationRestrictionsForTimePeriodsDocument = gql`
  query ValidateLocationRestrictionsForTimePeriods(
    $timePeriods: [DateIntervalInput!]!
    $workflowId: ObjectId!
    $locationIds: [ObjectId!]!
    $permitId: ObjectId
  ) {
    validateLocationRestrictionsForTimePeriods(
      timePeriods: $timePeriods
      workflowId: $workflowId
      locationIds: $locationIds
      permitId: $permitId
    ) {
      timePeriod {
        startDate
        endDate
      }
      locationResults {
        locationId
        isOverlappingAllowed
        violatedRestrictions
        conflictingPermits {
          id
          code
          startDate
          endDate
        }
      }
      isValid
    }
  }
`

/**
 * __useValidateLocationRestrictionsForTimePeriodsQuery__
 *
 * To run a query within a React component, call `useValidateLocationRestrictionsForTimePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLocationRestrictionsForTimePeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLocationRestrictionsForTimePeriodsQuery({
 *   variables: {
 *      timePeriods: // value for 'timePeriods'
 *      workflowId: // value for 'workflowId'
 *      locationIds: // value for 'locationIds'
 *      permitId: // value for 'permitId'
 *   },
 * });
 */
export function useValidateLocationRestrictionsForTimePeriodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IValidateLocationRestrictionsForTimePeriodsQuery,
    IValidateLocationRestrictionsForTimePeriodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IValidateLocationRestrictionsForTimePeriodsQuery,
    IValidateLocationRestrictionsForTimePeriodsQueryVariables
  >(ValidateLocationRestrictionsForTimePeriodsDocument, options)
}
export function useValidateLocationRestrictionsForTimePeriodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IValidateLocationRestrictionsForTimePeriodsQuery,
    IValidateLocationRestrictionsForTimePeriodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IValidateLocationRestrictionsForTimePeriodsQuery,
    IValidateLocationRestrictionsForTimePeriodsQueryVariables
  >(ValidateLocationRestrictionsForTimePeriodsDocument, options)
}
export type ValidateLocationRestrictionsForTimePeriodsQueryHookResult =
  ReturnType<typeof useValidateLocationRestrictionsForTimePeriodsQuery>
export type ValidateLocationRestrictionsForTimePeriodsLazyQueryHookResult =
  ReturnType<typeof useValidateLocationRestrictionsForTimePeriodsLazyQuery>
export type ValidateLocationRestrictionsForTimePeriodsQueryResult =
  Apollo.QueryResult<
    IValidateLocationRestrictionsForTimePeriodsQuery,
    IValidateLocationRestrictionsForTimePeriodsQueryVariables
  >
export const SaveEquipmentsDocument = gql`
  mutation SaveEquipments($equipments: [OffloadingEquipmentInput]!) {
    saveManyOffloadingEquipments(offloadingEquipments: $equipments) {
      id
    }
  }
`
export type ISaveEquipmentsMutationFn = Apollo.MutationFunction<
  ISaveEquipmentsMutation,
  ISaveEquipmentsMutationVariables
>

/**
 * __useSaveEquipmentsMutation__
 *
 * To run a mutation, you first call `useSaveEquipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEquipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEquipmentsMutation, { data, loading, error }] = useSaveEquipmentsMutation({
 *   variables: {
 *      equipments: // value for 'equipments'
 *   },
 * });
 */
export function useSaveEquipmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveEquipmentsMutation,
    ISaveEquipmentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveEquipmentsMutation,
    ISaveEquipmentsMutationVariables
  >(SaveEquipmentsDocument, options)
}
export type SaveEquipmentsMutationHookResult = ReturnType<
  typeof useSaveEquipmentsMutation
>
export type SaveEquipmentsMutationResult =
  Apollo.MutationResult<ISaveEquipmentsMutation>
export type SaveEquipmentsMutationOptions = Apollo.BaseMutationOptions<
  ISaveEquipmentsMutation,
  ISaveEquipmentsMutationVariables
>
export const UpdateLocationsPermittedCompaniesDocument = gql`
  mutation UpdateLocationsPermittedCompanies(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $permittedCompanies: [ObjectId!]!
  ) {
    updateLocationsPermittedCompanies(
      input: {
        projectId: $projectId
        locationIds: $locationIds
        permittedCompanies: $permittedCompanies
      }
    )
  }
`
export type IUpdateLocationsPermittedCompaniesMutationFn =
  Apollo.MutationFunction<
    IUpdateLocationsPermittedCompaniesMutation,
    IUpdateLocationsPermittedCompaniesMutationVariables
  >

/**
 * __useUpdateLocationsPermittedCompaniesMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsPermittedCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsPermittedCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsPermittedCompaniesMutation, { data, loading, error }] = useUpdateLocationsPermittedCompaniesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      permittedCompanies: // value for 'permittedCompanies'
 *   },
 * });
 */
export function useUpdateLocationsPermittedCompaniesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateLocationsPermittedCompaniesMutation,
    IUpdateLocationsPermittedCompaniesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateLocationsPermittedCompaniesMutation,
    IUpdateLocationsPermittedCompaniesMutationVariables
  >(UpdateLocationsPermittedCompaniesDocument, options)
}
export type UpdateLocationsPermittedCompaniesMutationHookResult = ReturnType<
  typeof useUpdateLocationsPermittedCompaniesMutation
>
export type UpdateLocationsPermittedCompaniesMutationResult =
  Apollo.MutationResult<IUpdateLocationsPermittedCompaniesMutation>
export type UpdateLocationsPermittedCompaniesMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateLocationsPermittedCompaniesMutation,
    IUpdateLocationsPermittedCompaniesMutationVariables
  >
export const UpdateLocationsIsBookableDocument = gql`
  mutation UpdateLocationsIsBookable(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $isBookable: Boolean!
  ) {
    updateLocationsIsBookable(
      input: {
        projectId: $projectId
        locationIds: $locationIds
        isBookable: $isBookable
      }
    )
  }
`
export type IUpdateLocationsIsBookableMutationFn = Apollo.MutationFunction<
  IUpdateLocationsIsBookableMutation,
  IUpdateLocationsIsBookableMutationVariables
>

/**
 * __useUpdateLocationsIsBookableMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsIsBookableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsIsBookableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsIsBookableMutation, { data, loading, error }] = useUpdateLocationsIsBookableMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      isBookable: // value for 'isBookable'
 *   },
 * });
 */
export function useUpdateLocationsIsBookableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateLocationsIsBookableMutation,
    IUpdateLocationsIsBookableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateLocationsIsBookableMutation,
    IUpdateLocationsIsBookableMutationVariables
  >(UpdateLocationsIsBookableDocument, options)
}
export type UpdateLocationsIsBookableMutationHookResult = ReturnType<
  typeof useUpdateLocationsIsBookableMutation
>
export type UpdateLocationsIsBookableMutationResult =
  Apollo.MutationResult<IUpdateLocationsIsBookableMutation>
export type UpdateLocationsIsBookableMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateLocationsIsBookableMutation,
    IUpdateLocationsIsBookableMutationVariables
  >
export const UpdateLocationsShowInMapDocument = gql`
  mutation UpdateLocationsShowInMap(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $showInMap: Boolean!
  ) {
    updateLocationsShowInMap(
      input: {
        projectId: $projectId
        locationIds: $locationIds
        showInMap: $showInMap
      }
    )
  }
`
export type IUpdateLocationsShowInMapMutationFn = Apollo.MutationFunction<
  IUpdateLocationsShowInMapMutation,
  IUpdateLocationsShowInMapMutationVariables
>

/**
 * __useUpdateLocationsShowInMapMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsShowInMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsShowInMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsShowInMapMutation, { data, loading, error }] = useUpdateLocationsShowInMapMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      showInMap: // value for 'showInMap'
 *   },
 * });
 */
export function useUpdateLocationsShowInMapMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateLocationsShowInMapMutation,
    IUpdateLocationsShowInMapMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateLocationsShowInMapMutation,
    IUpdateLocationsShowInMapMutationVariables
  >(UpdateLocationsShowInMapDocument, options)
}
export type UpdateLocationsShowInMapMutationHookResult = ReturnType<
  typeof useUpdateLocationsShowInMapMutation
>
export type UpdateLocationsShowInMapMutationResult =
  Apollo.MutationResult<IUpdateLocationsShowInMapMutation>
export type UpdateLocationsShowInMapMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateLocationsShowInMapMutation,
    IUpdateLocationsShowInMapMutationVariables
  >
export const UpdateLocationsOperatingIntervalsDocument = gql`
  mutation UpdateLocationsOperatingIntervals(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $operatingIntervals: [DateIntervalInput]!
  ) {
    updateLocationsOperatingIntervals(
      input: {
        projectId: $projectId
        locationIds: $locationIds
        operatingIntervals: $operatingIntervals
      }
    )
  }
`
export type IUpdateLocationsOperatingIntervalsMutationFn =
  Apollo.MutationFunction<
    IUpdateLocationsOperatingIntervalsMutation,
    IUpdateLocationsOperatingIntervalsMutationVariables
  >

/**
 * __useUpdateLocationsOperatingIntervalsMutation__
 *
 * To run a mutation, you first call `useUpdateLocationsOperatingIntervalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationsOperatingIntervalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationsOperatingIntervalsMutation, { data, loading, error }] = useUpdateLocationsOperatingIntervalsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      operatingIntervals: // value for 'operatingIntervals'
 *   },
 * });
 */
export function useUpdateLocationsOperatingIntervalsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateLocationsOperatingIntervalsMutation,
    IUpdateLocationsOperatingIntervalsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateLocationsOperatingIntervalsMutation,
    IUpdateLocationsOperatingIntervalsMutationVariables
  >(UpdateLocationsOperatingIntervalsDocument, options)
}
export type UpdateLocationsOperatingIntervalsMutationHookResult = ReturnType<
  typeof useUpdateLocationsOperatingIntervalsMutation
>
export type UpdateLocationsOperatingIntervalsMutationResult =
  Apollo.MutationResult<IUpdateLocationsOperatingIntervalsMutation>
export type UpdateLocationsOperatingIntervalsMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateLocationsOperatingIntervalsMutation,
    IUpdateLocationsOperatingIntervalsMutationVariables
  >
export const SaveIntegrationsDocument = gql`
  mutation SaveIntegrations($integrations: [IntegrationInput]!) {
    saveManyIntegrations(integrations: $integrations) {
      id
    }
  }
`
export type ISaveIntegrationsMutationFn = Apollo.MutationFunction<
  ISaveIntegrationsMutation,
  ISaveIntegrationsMutationVariables
>

/**
 * __useSaveIntegrationsMutation__
 *
 * To run a mutation, you first call `useSaveIntegrationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntegrationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntegrationsMutation, { data, loading, error }] = useSaveIntegrationsMutation({
 *   variables: {
 *      integrations: // value for 'integrations'
 *   },
 * });
 */
export function useSaveIntegrationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveIntegrationsMutation,
    ISaveIntegrationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveIntegrationsMutation,
    ISaveIntegrationsMutationVariables
  >(SaveIntegrationsDocument, options)
}
export type SaveIntegrationsMutationHookResult = ReturnType<
  typeof useSaveIntegrationsMutation
>
export type SaveIntegrationsMutationResult =
  Apollo.MutationResult<ISaveIntegrationsMutation>
export type SaveIntegrationsMutationOptions = Apollo.BaseMutationOptions<
  ISaveIntegrationsMutation,
  ISaveIntegrationsMutationVariables
>
export const DeleteLocationsDocument = gql`
  mutation DeleteLocations($ids: [ObjectId]!) {
    softDeleteManyLocations(ids: $ids)
  }
`
export type IDeleteLocationsMutationFn = Apollo.MutationFunction<
  IDeleteLocationsMutation,
  IDeleteLocationsMutationVariables
>

/**
 * __useDeleteLocationsMutation__
 *
 * To run a mutation, you first call `useDeleteLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationsMutation, { data, loading, error }] = useDeleteLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLocationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteLocationsMutation,
    IDeleteLocationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteLocationsMutation,
    IDeleteLocationsMutationVariables
  >(DeleteLocationsDocument, options)
}
export type DeleteLocationsMutationHookResult = ReturnType<
  typeof useDeleteLocationsMutation
>
export type DeleteLocationsMutationResult =
  Apollo.MutationResult<IDeleteLocationsMutation>
export type DeleteLocationsMutationOptions = Apollo.BaseMutationOptions<
  IDeleteLocationsMutation,
  IDeleteLocationsMutationVariables
>
export const SaveManyWorkflowLocationRestrictionsDocument = gql`
  mutation SaveManyWorkflowLocationRestrictions(
    $workflowLocationRestrictions: [WorkflowLocationRestrictionInput]!
  ) {
    saveManyWorkflowLocationRestrictions(
      workflowLocationRestrictions: $workflowLocationRestrictions
    ) {
      id
    }
  }
`
export type ISaveManyWorkflowLocationRestrictionsMutationFn =
  Apollo.MutationFunction<
    ISaveManyWorkflowLocationRestrictionsMutation,
    ISaveManyWorkflowLocationRestrictionsMutationVariables
  >

/**
 * __useSaveManyWorkflowLocationRestrictionsMutation__
 *
 * To run a mutation, you first call `useSaveManyWorkflowLocationRestrictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManyWorkflowLocationRestrictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManyWorkflowLocationRestrictionsMutation, { data, loading, error }] = useSaveManyWorkflowLocationRestrictionsMutation({
 *   variables: {
 *      workflowLocationRestrictions: // value for 'workflowLocationRestrictions'
 *   },
 * });
 */
export function useSaveManyWorkflowLocationRestrictionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveManyWorkflowLocationRestrictionsMutation,
    ISaveManyWorkflowLocationRestrictionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveManyWorkflowLocationRestrictionsMutation,
    ISaveManyWorkflowLocationRestrictionsMutationVariables
  >(SaveManyWorkflowLocationRestrictionsDocument, options)
}
export type SaveManyWorkflowLocationRestrictionsMutationHookResult = ReturnType<
  typeof useSaveManyWorkflowLocationRestrictionsMutation
>
export type SaveManyWorkflowLocationRestrictionsMutationResult =
  Apollo.MutationResult<ISaveManyWorkflowLocationRestrictionsMutation>
export type SaveManyWorkflowLocationRestrictionsMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveManyWorkflowLocationRestrictionsMutation,
    ISaveManyWorkflowLocationRestrictionsMutationVariables
  >
export const DeleteManyWorkflowLocationRestrictionsDocument = gql`
  mutation DeleteManyWorkflowLocationRestrictions($ids: [ObjectId]!) {
    deleteManyWorkflowLocationRestrictions(ids: $ids)
  }
`
export type IDeleteManyWorkflowLocationRestrictionsMutationFn =
  Apollo.MutationFunction<
    IDeleteManyWorkflowLocationRestrictionsMutation,
    IDeleteManyWorkflowLocationRestrictionsMutationVariables
  >

/**
 * __useDeleteManyWorkflowLocationRestrictionsMutation__
 *
 * To run a mutation, you first call `useDeleteManyWorkflowLocationRestrictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyWorkflowLocationRestrictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyWorkflowLocationRestrictionsMutation, { data, loading, error }] = useDeleteManyWorkflowLocationRestrictionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteManyWorkflowLocationRestrictionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteManyWorkflowLocationRestrictionsMutation,
    IDeleteManyWorkflowLocationRestrictionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteManyWorkflowLocationRestrictionsMutation,
    IDeleteManyWorkflowLocationRestrictionsMutationVariables
  >(DeleteManyWorkflowLocationRestrictionsDocument, options)
}
export type DeleteManyWorkflowLocationRestrictionsMutationHookResult =
  ReturnType<typeof useDeleteManyWorkflowLocationRestrictionsMutation>
export type DeleteManyWorkflowLocationRestrictionsMutationResult =
  Apollo.MutationResult<IDeleteManyWorkflowLocationRestrictionsMutation>
export type DeleteManyWorkflowLocationRestrictionsMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteManyWorkflowLocationRestrictionsMutation,
    IDeleteManyWorkflowLocationRestrictionsMutationVariables
  >
export const DisableLocationsAndClearControlsDocument = gql`
  mutation DisableLocationsAndClearControls(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
  ) {
    disableLocationsAndClearControls(
      input: { projectId: $projectId, locationIds: $locationIds }
    ) {
      ...ResourceControlCascadeFields
    }
  }
  ${ResourceControlCascadeFieldsFragmentDoc}
`
export type IDisableLocationsAndClearControlsMutationFn =
  Apollo.MutationFunction<
    IDisableLocationsAndClearControlsMutation,
    IDisableLocationsAndClearControlsMutationVariables
  >

/**
 * __useDisableLocationsAndClearControlsMutation__
 *
 * To run a mutation, you first call `useDisableLocationsAndClearControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableLocationsAndClearControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableLocationsAndClearControlsMutation, { data, loading, error }] = useDisableLocationsAndClearControlsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useDisableLocationsAndClearControlsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDisableLocationsAndClearControlsMutation,
    IDisableLocationsAndClearControlsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDisableLocationsAndClearControlsMutation,
    IDisableLocationsAndClearControlsMutationVariables
  >(DisableLocationsAndClearControlsDocument, options)
}
export type DisableLocationsAndClearControlsMutationHookResult = ReturnType<
  typeof useDisableLocationsAndClearControlsMutation
>
export type DisableLocationsAndClearControlsMutationResult =
  Apollo.MutationResult<IDisableLocationsAndClearControlsMutation>
export type DisableLocationsAndClearControlsMutationOptions =
  Apollo.BaseMutationOptions<
    IDisableLocationsAndClearControlsMutation,
    IDisableLocationsAndClearControlsMutationVariables
  >
export const UpdateResourceControlsDocument = gql`
  mutation UpdateResourceControls(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $permittedCompanies: [ObjectId!]
    $operatingIntervals: [DateIntervalInput]
    $isBookable: Boolean
    $workflowRestrictions: [UpdateResourceControlsRestrictionInput!]
    $closures: [LocationClosureIntervalInput!]
  ) {
    updateResourceControls(
      input: {
        projectId: $projectId
        locationIds: $locationIds
        permittedCompanies: $permittedCompanies
        operatingIntervals: $operatingIntervals
        isBookable: $isBookable
        workflowRestrictions: $workflowRestrictions
        closures: $closures
      }
    ) {
      ...ResourceControlCascadeFields
    }
  }
  ${ResourceControlCascadeFieldsFragmentDoc}
`
export type IUpdateResourceControlsMutationFn = Apollo.MutationFunction<
  IUpdateResourceControlsMutation,
  IUpdateResourceControlsMutationVariables
>

/**
 * __useUpdateResourceControlsMutation__
 *
 * To run a mutation, you first call `useUpdateResourceControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceControlsMutation, { data, loading, error }] = useUpdateResourceControlsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      permittedCompanies: // value for 'permittedCompanies'
 *      operatingIntervals: // value for 'operatingIntervals'
 *      isBookable: // value for 'isBookable'
 *      workflowRestrictions: // value for 'workflowRestrictions'
 *      closures: // value for 'closures'
 *   },
 * });
 */
export function useUpdateResourceControlsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateResourceControlsMutation,
    IUpdateResourceControlsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateResourceControlsMutation,
    IUpdateResourceControlsMutationVariables
  >(UpdateResourceControlsDocument, options)
}
export type UpdateResourceControlsMutationHookResult = ReturnType<
  typeof useUpdateResourceControlsMutation
>
export type UpdateResourceControlsMutationResult =
  Apollo.MutationResult<IUpdateResourceControlsMutation>
export type UpdateResourceControlsMutationOptions = Apollo.BaseMutationOptions<
  IUpdateResourceControlsMutation,
  IUpdateResourceControlsMutationVariables
>
export const PreviewResourceControlCascadeDocument = gql`
  query PreviewResourceControlCascade(
    $projectId: ObjectId!
    $locationIds: [ObjectId!]!
    $proposedIsBookable: Boolean
  ) {
    previewResourceControlCascade(
      projectId: $projectId
      locationIds: $locationIds
      proposedIsBookable: $proposedIsBookable
    ) {
      ...ResourceControlCascadeFields
    }
  }
  ${ResourceControlCascadeFieldsFragmentDoc}
`

/**
 * __usePreviewResourceControlCascadeQuery__
 *
 * To run a query within a React component, call `usePreviewResourceControlCascadeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewResourceControlCascadeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewResourceControlCascadeQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      locationIds: // value for 'locationIds'
 *      proposedIsBookable: // value for 'proposedIsBookable'
 *   },
 * });
 */
export function usePreviewResourceControlCascadeQuery(
  baseOptions: Apollo.QueryHookOptions<
    IPreviewResourceControlCascadeQuery,
    IPreviewResourceControlCascadeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IPreviewResourceControlCascadeQuery,
    IPreviewResourceControlCascadeQueryVariables
  >(PreviewResourceControlCascadeDocument, options)
}
export function usePreviewResourceControlCascadeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPreviewResourceControlCascadeQuery,
    IPreviewResourceControlCascadeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IPreviewResourceControlCascadeQuery,
    IPreviewResourceControlCascadeQueryVariables
  >(PreviewResourceControlCascadeDocument, options)
}
export type PreviewResourceControlCascadeQueryHookResult = ReturnType<
  typeof usePreviewResourceControlCascadeQuery
>
export type PreviewResourceControlCascadeLazyQueryHookResult = ReturnType<
  typeof usePreviewResourceControlCascadeLazyQuery
>
export type PreviewResourceControlCascadeQueryResult = Apollo.QueryResult<
  IPreviewResourceControlCascadeQuery,
  IPreviewResourceControlCascadeQueryVariables
>
export const ListenToWorkflowLocationRestrictionDocument = gql`
  subscription ListenToWorkflowLocationRestriction($projectId: ObjectId!) {
    workflowLocationRestriction(projectId: $projectId) {
      id
      item {
        ...WorkflowLocationRestrictionFields
      }
    }
  }
  ${WorkflowLocationRestrictionFieldsFragmentDoc}
`

/**
 * __useListenToWorkflowLocationRestrictionSubscription__
 *
 * To run a query within a React component, call `useListenToWorkflowLocationRestrictionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToWorkflowLocationRestrictionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToWorkflowLocationRestrictionSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenToWorkflowLocationRestrictionSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToWorkflowLocationRestrictionSubscription,
    IListenToWorkflowLocationRestrictionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToWorkflowLocationRestrictionSubscription,
    IListenToWorkflowLocationRestrictionSubscriptionVariables
  >(ListenToWorkflowLocationRestrictionDocument, options)
}
export type ListenToWorkflowLocationRestrictionSubscriptionHookResult =
  ReturnType<typeof useListenToWorkflowLocationRestrictionSubscription>
export type ListenToWorkflowLocationRestrictionSubscriptionResult =
  Apollo.SubscriptionResult<IListenToWorkflowLocationRestrictionSubscription>
export const ListenLocationsByProjectIdDocument = gql`
  subscription ListenLocationsByProjectId($projectId: ObjectId!) {
    location(projectId: $projectId) {
      id
      item {
        id
        projectId
        type
        name
        operatingIntervals {
          startDate
          endDate
          isDaily
          dayOfWeek
        }
        color
        iconName
        permittedCompanies
        maxOverlappingDeliveries
        maxBookingDuration
        workflowRestrictions {
          maxBookingDurations {
            ...WorkflowLocationRestrictionFields
          }
          maxOverlappingBookings {
            ...WorkflowLocationRestrictionFields
          }
        }
        code
        stxResourceId
        templateId
        data
        isBookable
        showInMap
        assignedSitemaps
        assignedGlobes
        isDeleted
        parent {
          parentId
        }
        ... on Integration {
          metadata {
            key
            value
          }
        }
        ... on Location {
          isNameImplicit
          levelsOrder
          groundLevel
          isGroundIndexZero
          skipLevelIndexTemplate
          levelBaseName
          accessibleLevels
          levelsClosures {
            levels
            interval {
              startDate
              endDate
            }
          }
          maxHeight
          maxWidth
          maxWeight
          isLinked
        }
        ... on Level {
          isNameImplicit
        }
        ... on Building {
          levelsOrder
          groundLevel
          isGroundIndexZero
          skipLevelIndexTemplate
          levelBaseName
        }
        ... on VerticalObject {
          accessibleLevels
          levelsClosures {
            levels
            interval {
              startDate
              endDate
            }
          }
        }
        ... on OffloadingEquipment {
          templateId
          data
          showInMap
          accessibleLevels
          rollups
          isBookable
          linkedSensor {
            id
            name
            infuseId
            data
          }
          effectivePosition {
            source
            latitude
            longitude
            lastUpdatedAt
          }
        }
        ... on Sensor {
          ...SensorResourceFields
        }
        ... on Material {
          templateId
          data
          rollups
          isBookable
        }
        ... on InteriorDoor {
          maxHeight
          maxWidth
          maxWeight
        }
        ... on InteriorPath {
          maxHeight
          maxWidth
          maxWeight
        }
        ... on ProjectLocation {
          isLinked
        }
        createdAt
        updatedAt
      }
    }
  }
  ${WorkflowLocationRestrictionFieldsFragmentDoc}
  ${SensorResourceFieldsFragmentDoc}
`

/**
 * __useListenLocationsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenLocationsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenLocationsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenLocationsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenLocationsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenLocationsByProjectIdSubscription,
    IListenLocationsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenLocationsByProjectIdSubscription,
    IListenLocationsByProjectIdSubscriptionVariables
  >(ListenLocationsByProjectIdDocument, options)
}
export type ListenLocationsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenLocationsByProjectIdSubscription
>
export type ListenLocationsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenLocationsByProjectIdSubscription>
